import { api } from '../_client';
import type { Payload, Pilot, Customer, Project, OrgMember } from '../../../types/api';

export const filesLookupsApi = {
  // Get available payloads
  async getPayloads(): Promise<Payload[]> {
    const response = await api.get('/api/files/payloads');
    return response.data;
  },

  // Create a new payload
  async createPayload(name: string, weight?: number): Promise<Payload> {
    const response = await api.post('/api/files/payloads', { name, weight });
    return response.data;
  },

  // Get available pilots (organization members)
  async getPilots(): Promise<Pilot[]> {
    const response = await api.get('/api/files/pilots');
    return response.data;
  },

  // Get available customers (org-scoped)
  async getCustomers(): Promise<Customer[]> {
    const response = await api.get('/api/customers');
    return response.data;
  },

  // Get available projects (org-scoped)
  async getProjects(): Promise<Project[]> {
    const response = await api.get('/api/projects');
    return response.data;
  },

  // Create a new customer
  async createCustomer(name: string): Promise<Customer> {
    const response = await api.post('/api/customers', { name });
    return response.data;
  },

  // Create a new project
  async createProject(name: string): Promise<Project> {
    const response = await api.post('/api/projects', { name });
    return response.data;
  },

  // Get available airspace observers (org members with airspace_observer role)
  async getAirspaceObservers(): Promise<OrgMember[]> {
    const response = await api.get('/api/files/airspace-observers');
    return response.data;
  },

  // Get available payload operators (all org members)
  async getPayloadOperators(): Promise<OrgMember[]> {
    const response = await api.get('/api/files/payload-operators');
    return response.data;
  },
};
